module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "font-weight-bold darkgrey--text"
  }, [_vm._v("\n        " + _vm._s(_vm.$attrs.detail.intrepretation_id ? "Ubah" : "Tambah") + "\n        Interpretasi\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-5"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n            " + _vm._s(_vm.$attrs.scale.question_type === "choice" ?
    "Kode Dominan" :
    "Rentang Score") + "\n        ")]), _vm._v(" "), (_vm.$attrs.scale.question_type === 'choice') ? _c('div', {
    staticClass: "mt-2",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('div', [_c('v-select', {
    attrs: {
      "items": _vm.value_answer,
      "outlined": "",
      "placeholder": "Kode"
    },
    model: {
      value: (_vm.data.most_result),
      callback: function($$v) {
        _vm.$set(_vm.data, "most_result", $$v)
      },
      expression: "data.most_result"
    }
  })], 1)]) : _c('div', {
    staticClass: "d-flex mt-2",
    staticStyle: {
      "align-items": "baseline",
      "gap": "10px",
      "width": "80%"
    }
  }, [_c('div', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Score",
      "maxlength": "3"
    },
    on: {
      "keypress": function($event) {
        return _vm.handleInputNumber($event)
      }
    },
    model: {
      value: (_vm.data.min_result),
      callback: function($$v) {
        _vm.$set(_vm.data, "min_result", $$v)
      },
      expression: "data.min_result"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("sampai")])]), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Score",
      "maxlength": "3"
    },
    on: {
      "keypress": function($event) {
        return _vm.handleInputNumber($event)
      }
    },
    model: {
      value: (_vm.data.max_result),
      callback: function($$v) {
        _vm.$set(_vm.data, "max_result", $$v)
      },
      expression: "data.max_result"
    }
  })], 1)])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-3"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(" Tutup ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "depressed": "",
      "text": "",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("\n            Simpan\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f8d698","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/DialogRange.vue
// module id = 1477
// module chunks = 1